import React from "react";
import "./upcomingEvent.css";

const UpcomingEvent = () => {
  return (
    <div className="upcoming_event">
      <div className="upcoming_event_content">
        <h2>Upcoming Events</h2>
        <ul>
          <li>
            <h6>
              <span>1</span>9h30 - 10h30
            </h6>
            <h4>Drawing Fundamental Class</h4>
            <p>Amet minim mollit non deserunt</p>
          </li>
          <li>
            <h6>
              <span>2</span>12h30 - 14h30
            </h6>
            <h4>Live Class</h4>
            <p>Amet minim mollit non deserunt</p>
          </li>
          <li>
            <h6>
              <span>3</span>15h00 - 17h30
            </h6>
            <h4>Meeting with students</h4>
            <p>Amet minim mollit non deserunt</p>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default UpcomingEvent;
